import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTabletComponent } from "./med-icon-tablet.component";

@NgModule({
  declarations: [
    MedIconTabletComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTabletComponent,
  ],
})
export class MedIconTabletModule { }
